// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import MaskedInput from "react-text-mask";

import { phoneNumberMask } from "../../../../Constants/GlobalVariables/InputMasks";
import emailMask from "text-mask-addons/dist/emailMask";

type PropsType = {
  formElements: Object,
  translate: string => void,
  initialRequestFormElementValueChange: (string, string) => void,
  initialRequestFormSubmit: Object => void
};

type StateType = {};

class InitialRequestForm extends Component<PropsType, StateType> {
  render() {
    const {
      formElements,
      translate,
      initialRequestFormElementValueChange,
      initialRequestFormSubmit
    } = this.props;
    return (
      <div>
        <p className="mb-3 text-center">{translate("InitialRequestLocale.form.header")}</p>
        <hr className="w-30" />
        <p className="mb-3 text-center">{translate("InitialRequestLocale.form.form_unit.header")}</p>
        <div className="form-row text-center">
          <div className="form-group col-md-8 offset-2">
            <div className="btn-group btn-group-sm" role="group" aria-label="Basic example">
              <button
                type="button"
                className={`btn ${formElements.type === "C" ? "btn-label btn-primary" : "btn-secondary"}`}
                onClick={() => {
                  initialRequestFormElementValueChange("type", "C");
                }}
              >
                {formElements.type === "C" ? (
                  <label>
                    <i className="fas fa-check" />
                  </label>
                ) : null}

                {translate("InitialRequestLocale.form.form_unit.type.customer")}
              </button>
              <button
                type="button"
                className={`btn ${formElements.type === "P" ? "btn-label btn-primary" : "btn-secondary"}`}
                onClick={() => {
                  initialRequestFormElementValueChange("type", "P");
                }}
              >
                {formElements.type === "P" ? (
                  <label>
                    <i className="fas fa-check" />
                  </label>
                ) : null}
                {translate("InitialRequestLocale.form.form_unit.type.partner")}
              </button>
            </div>
          </div>
          <div className="form-group col-md-8 offset-2">
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("InitialRequestLocale.form.form_unit.full_name")}
              value={formElements.full_name}
              name="full_name"
              onChange={event => {
                initialRequestFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <MaskedInput
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("InitialRequestLocale.form.form_unit.email")}
              value={formElements.email}
              mask={emailMask}
              name="email"
              onChange={event => {
                initialRequestFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <MaskedInput
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("InitialRequestLocale.form.form_unit.telephone_number")}
              value={formElements.telephone_number}
              mask={phoneNumberMask}
              name="telephone_number"
              onChange={event => {
                initialRequestFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("InitialRequestLocale.form.form_unit.company_name")}
              value={formElements.company_name}
              name="company_name"
              onChange={event => {
                initialRequestFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <textarea
              className="form-control form-control-sm"
              rows="4"
              type="text"
              placeholder={translate("InitialRequestLocale.form.form_unit.company_desc")}
              value={formElements.company_desc}
              name="company_desc"
              onChange={event => {
                initialRequestFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <textarea
              className="form-control form-control-sm"
              rows="4"
              type="text"
              placeholder={translate("InitialRequestLocale.form.form_unit.process_requirements")}
              value={formElements.process_requirements}
              name="process_requirements"
              onChange={event => {
                initialRequestFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <button
              className="btn btn-block btn-primary"
              onClick={() => {
                initialRequestFormSubmit(formElements);
              }}
            >
              {translate("InitialRequestLocale.form.form_unit.submit")}
            </button>
          </div>
        </div>
        <hr className="w-30" />
        <p className="text-center text-muted small-2">
          {translate("InitialRequestLocale.form.footer.content")}{" "}
          <Link to="/giris">{translate("InitialRequestLocale.form.footer.login_link")}</Link>
        </p>
      </div>
    );
  }
}

export default InitialRequestForm;



// WEBPACK FOOTER //
// ./src/Components/PublicAccountPages/Components/InitialRequest/InitialRequestForm.js